// Centred max-width slab. Replaces the recurring
// <main style={{ maxWidth, margin, padding }}> idiom across pages.
const SIZES = {
  sm: 640,
  md: 880,
  lg: 1080,
  xl: 1200,
  smxl: 1360,
  mdxl: 1720,
  mdlg: '90%',
  full: '100%',
};

export default function Container({
  size = 'lg',
  as = 'main',
  padded = true,
  className,
  style,
  children,
}) {
  const Tag = as;
  const maxWidth = SIZES[size] ?? size;
  return (
    <Tag
      className={className}
      style={{
        maxWidth,
        margin: '0 auto',
        padding: padded ? '2rem 1.5rem' : 0,
        width: '100%',
        ...style,
      }}
    >
      {children}
    </Tag>
  );
}
